// Sets sessionStorage flag to identify the activating tab
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  markActiveTab() {
    sessionStorage.setItem('superuser_activated_here', 'true')
  }
}
